import isPlainObject from "lodash/isPlainObject";

/**
  @hide
*/
export default function (object) {
  return isPlainObject(object) && object.__isAssociation__ === true;
}
